<div class="dialog">
  <form [formGroup]="form" (keydown.enter)="$event.stopPropagation()">
    <h4 mat-dialog-title>{{ 'dialog_structure_title' | translate }}</h4>
    <mat-card>
      <mat-grid-list cols="10" rowHeight="60px" gutterSize="20px">
        <mat-grid-tile colspan="5">
          <mat-form-field>
            <mat-label>{{ 'dialog_structure_field_name' | translate }}</mat-label>
            <input matInput formControlName="displayName" required />
            <mat-error *ngIf="formCrls.displayName.invalid">{{ 'dialog_substructure_error_label' | translate }}</mat-error>
          </mat-form-field>
        </mat-grid-tile>
      </mat-grid-list>
    </mat-card>
    <div mat-dialog-actions>
      <button type="button" mat-button (click)="onNoClick()">{{ 'common_btn_cancel' | translate }}</button>
      <button mat-button [mat-dialog-close]="form?.value" color="accent" [disabled]="!form.valid">{{ 'common_btn_save' | translate }}</button>
    </div>
  </form>
</div>
